// extracted by mini-css-extract-plugin
export default {"newDot":"LX_CxRL0K7A5Z_Nzj1r2"};